import { FileResponsePrivate } from '@tests/types';
import classNames from 'classnames';
import React, { CSSProperties, FC } from 'react';
import ReactPlayer from 'react-player';

import { ImageSize } from '@/constants';
import { useGetImageUrl } from '@/utils';

import styles from './styles.module.scss';

interface Props {
  backgroundSize?: string;
  file: FileResponsePrivate;
  imageSize?: ImageSize;
  rootClassName?: string;
}

export const DropZoneFilePreview: FC<Props> = ({
  backgroundSize,
  file,
  imageSize,
  rootClassName,
}) => {
  const getImageUrl = useGetImageUrl();

  return (
    <div className={classNames(styles.previewWrapper, rootClassName)}>
      {file.type === 'image' && (
        <img
          alt=""
          className={styles.previewImage}
          style={{ objectFit: backgroundSize as CSSProperties['objectFit'] }}
          src={getImageUrl({ options: imageSize ? { resize: imageSize } : undefined, url: file.url })}
        />
      )}
      {file.type === 'video' && <ReactPlayer url={file.url} controls width="100%" height="100%" />}
    </div>
  );
};
